import styled from "styled-components";
import Typography from "@/foundation/Typography/V2";
import { FlexDiv } from "../../../Atoms/Box";

export const HeadingWrapper = styled(FlexDiv)`
  width: 100%;
  border-bottom-style: solid;
`;
export const Heading = styled(Typography)``;
